import { FaGraduationCap, FaTasks, FaBriefcase } from 'react-icons/fa';
import { MdDone } from "react-icons/md";
import { useAuthContext } from '../../../../Context/AuthContext';
import { useSearchParams } from 'react-router-dom';



function Step6() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { nextStep, extraInfo, updateExtraInfo, adminInfo } = useAuthContext();
  const email = searchParams.get('email');
  console.log(email);

  const handlePackageSelection = (selectedPackageId) => {
    console.log(selectedPackageId);
    updateExtraInfo({ package_id: selectedPackageId })
    nextStep();
    setSearchParams({ step: 7, email: email });
  };

  return (
    <div className="h-screen">
      <div className="h-full overflow-y-auto">
        <div className="flex justify-center items-center px-4 py-8 min-h-full">
          <div className="w-full max-w-6xl">
            <h1 className="mb-6 w-full text-[#8a25b0] text-xl text-center">Tell us who you are to customize your Flowchanger Workspace</h1>
            <div className="gap-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-[10px] max-w-6xl">
              {/* Student card */}
              <div className="flex flex-col items-center bg-white shadow-cs p-6 rounded-lg text-center hover:-translate-y-2.5 duration-700 cursor-pointer hover:transform">
                <FaGraduationCap className="mb-4 text-[#8a25b0] text-4xl" />
                <h2 className="mb-2 font-semibold text-xl">I'm a student</h2>
                <p className="mb-4 text-gray-500">For education purposes only</p>
                <ul className="space-y-2 text-left list-none">
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Schedule your classes</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Prepare for exams with structured study plans</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Set reminders for assignments and tests</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div>Track your daily progress</li>
                </ul>
                <button
                  onClick={() => handlePackageSelection(1)}
                  className="bg-[#8a25b0] hover:bg-[#884a9f] mt-auto px-4 py-2 rounded-full w-[100%] text-white">
                  Choose
                </button>
              </div>

              {/* Personal Tasks Card */}
              <div className="flex flex-col items-center bg-white shadow-cs p-6 rounded-lg text-center hover:-translate-y-2.5 duration-700 cursor-pointer hover:transform">
                <FaTasks className="mb-4 text-[#8a25b0] text-4xl" />
                <h2 className="mb-2 font-semibold text-xl">I will use Flowchanger for organizing personal tasks</h2>
                <p className="mb-4 text-gray-500">Non-commercial use only</p>
                <ul className="space-y-2 text-left list-none">
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> <span>Organize your personal tasks</span></li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> <span>Plan personal events, like birthdays or vacations</span> </li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> <span>Set repeats for recurring activities</span></li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> <span>Organize personal projects</span></li>
                </ul>
                <button
                  onClick={() => handlePackageSelection(2)}
                  className="bg-[#8a25b0] hover:bg-[#884a9f] mt-auto px-4 py-2 rounded-full w-[100%] text-white">
                  Choose
                </button>
              </div>

              {/* Business Card */}
              <div className="flex flex-col items-center bg-white shadow-cs p-6 rounded-lg text-center hover:-translate-y-2.5 duration-700 cursor-pointer hover:transform">
                <FaBriefcase className="mb-4 text-[#8a25b0] text-4xl" />
                <h2 className="mb-2 font-semibold text-xl">I represent a business or organization</h2>
                <p className="mb-4 text-gray-500">Free 14 days trial</p>
                <ul className="space-y-2 mb-2 text-left list-none">
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Invite colleagues to the teams and projects</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Assign tasks to your teammates, set deadlines and track the progress</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Switch between views: Calendar planner, Kanban board, Task list</li>
                  <li className='flex items-start'>  <div className='flex-shrink-0 bg-[#8a25b0] mr-2 p-1 rounded-full'>
                    <MdDone className='w-3 h-3 text-white' />
                  </div> Discuss tasks in real-time chat</li>
                </ul>
                <button
                  onClick={() => handlePackageSelection(3)}
                  className="bg-[#8a25b0] hover:bg-[#884a9f] mt-auto px-4 py-2 rounded-full w-[100%] text-white">
                  Choose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step6;